"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NuestraEsencia() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="nuestra-esencia" ref={sectionRef} className="bg-background py-32 px-6 md:px-12 lg:px-24">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {}
        <div className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
        transitionDelay: "0ms"
      }}>
          <div className="relative rounded-lg overflow-hidden shadow-medium hover-lift">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/restaurant_interior_high_res.png" alt="Interior elegante de restaurante Marea Mezcal en Playa del Carmen" className="w-full h-auto object-cover" />
          </div>
        </div>

        {}
        <div className="space-y-12">
          {}
          <h2 className={`font-display text-4xl md:text-5xl lg:text-6xl font-bold text-foreground leading-tight transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
          transitionDelay: "120ms"
        }}>
            Nuestra Esencia
          </h2>

          {}
          <div className="space-y-6">
            <p className={`text-foreground text-lg md:text-xl leading-loose max-w-xl line-clamp-4 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: "240ms"
          }}>
              En Marea Mezcal, fusionamos la tradición culinaria mexicana con técnicas contemporáneas 
              para crear experiencias gastronómicas únicas. Cada plato cuenta una historia, cada sabor 
              rinde homenaje a nuestras raíces mientras abraza la innovación. Nuestro ambiente tropical-lujoso 
              frente al mar en Playa del Carmen ofrece el escenario perfecto para una velada inolvidable.
            </p>
            <p className={`text-foreground/80 font-medium italic transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: "300ms"
          }}>
              Descubre la historia detrás de cada sabor.
            </p>
          </div>

          {}
          <div className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
          transitionDelay: "360ms"
        }}>
            <Link to="/EssencePage">
              <Button className="btn-primary">
                Conocer más
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}